import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.colors.white,
        margin: '16px 0',
        maxWidth: 570,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        ...theme.typographyPresets.titleSmallBold,
    },
}))
